/**
 * Active firm staff for assignment dropdowns (Tasks, Cases, Intake, etc.).
 * Always returns an array so React Query cache shape stays consistent.
 */
import { getAuthToken } from './authToken';

export type AssignableUser = {
  id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  role?: string;
};

export async function fetchAssignableUsers(): Promise<AssignableUser[]> {
  const token = getAuthToken();
  if (!token) return [];

  const response = await fetch('/api/users/assignable', {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) return [];

  const json = await response.json().catch(() => null);
  const list = json?.data?.users;
  return Array.isArray(list) ? list : [];
}

export const ASSIGNABLE_USERS_QUERY_KEY = ['users', 'assignable'] as const;

/** Normalize cached/query data that may be an array or a legacy API envelope. */
export function asAssignableUsers(data: unknown): AssignableUser[] {
  if (Array.isArray(data)) return data;
  if (data && typeof data === 'object') {
    const nested = (data as { data?: { users?: unknown } }).data?.users;
    if (Array.isArray(nested)) return nested;
    const users = (data as { users?: unknown }).users;
    if (Array.isArray(users)) return users;
  }
  return [];
}
